module.exports = __webpack_public_path__ + "img/ppt-icon.75ec456a.svg";